import React, { ReactNode } from 'react';
import cx from 'classnames';
import { capitalize } from '../../utils';
import styles from './Icon.module.scss';

export interface IconProp {
  className?: Parameters<typeof cx>[0];
  contrast?:
    | 'default'
    | 'low'
    | 'high'
    | 'inverse-default'
    | 'inverse-low'
    | 'inverse-high';
  accessibilityLabel?: string;
  children: ReactNode;
  size?: 14 | 16 | 18 | 20;
}

export const Svg = ({
  accessibilityLabel,
  contrast,
  className,
  children,
  size,
  ...restProps
}: IconProp) => (
  <svg
    aria-hidden={!accessibilityLabel && true}
    role={accessibilityLabel != null ? 'img' : 'presentation'}
    aria-label={accessibilityLabel}
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={cx(
      styles.icon,
      contrast && styles[`iconContrast${capitalize(contrast)}`],
      className,
    )}
    {...restProps}
  >
    {children}
  </svg>
);

export default Svg;
